module.exports = __webpack_public_path__ + "img/wj.d794882b.png";